// to load sound and trigger sounds
import * as THREE from "three";
import { PositionalAudioHelper } from "three/examples/jsm/helpers/PositionalAudioHelper";
import { SoundDataLocal } from "./soundData.js";

export class Sound {
  static SOUNDS = {
    start_sound:
      "https://media.exiledracers.com/assets/game/builder/Start_Sound_1_1661802248171.mp3",
    first_lap:
      "https://media.exiledracers.com/assets/game/builder/First_Lap_1_1661802285578.mp3",
    lap_sound:
      "https://media.exiledracers.com/assets/game/builder/Lap_Sound_1_1661802318532.mp3",
    ambient_bed:
      "https://media.exiledracers.com/assets/game/builder/Ambient_Bed_1_1661802348336.mp3",
    final_lap:
      "https://media.exiledracers.com/assets/game/builder/Final_Lap_1_1661802467090.mp3",
    blast:
      "https://media.exiledracers.com/assets/game/builder/Blast_1663806769662.mp3",
    rumble:
      "https://media.exiledracers.com/assets/game/builder/Rumble_1663806797661.mp3",
    close_rumble:
      "https://media.exiledracers.com/assets/game/builder/Close_Rumble_1663806832506.wav",
    end_sound:
      "https://media.exiledracers.com/assets/game/builder/End_Sound_1663806874289.mp3",
  };

  static POS_SOUNDS = {
    shipSound1:
      "https://media.exiledracers.com/assets/game/builder/Ship_Passing_5_1663806360050.mp3",
    shipSound2:
      "https://media.exiledracers.com/assets/game/builder/Ship_Passing_4_1663806338546.mp3",
    shipSound3:
      "https://media.exiledracers.com/assets/game/builder/Ship_Passing_3_1661802550161.mp3",
    shipSound4:
      "https://media.exiledracers.com/assets/game/builder/Ship_Passing_2_1661802535716.mp3",
    shipSound5:
      "https://media.exiledracers.com/assets/game/builder/Ship_Passing_1_1661802507901.wav",
  };

  /**
   * Construct the sound object
   */
  constructor() {
    this.listener = new THREE.AudioListener();
    this.loaded = {};
    this.posloaded = {};

    this.loadSounds();
    this.loadPosSounds();
  }

  setCamera(camera) {
    camera.add(this.listener);
  }

  loadSounds() {
    const loader = new THREE.AudioLoader();

    for (const sound of Object.keys(Sound.SOUNDS))
      loader.load(Sound.SOUNDS[sound], (buffer) => {
        const audio = new THREE.Audio(this.listener);

        audio.setBuffer(buffer);
        // audio.setVolume(0.3);
        audio.setLoop(false);

        this.loaded[sound] = audio;
      });
    // console.log(this.loaded);
    // console.log(new SoundDataLocal());
  }

  muteAllSounds() {
    for (const sound of Object.keys(Sound.SOUNDS)) {
      if (this.loaded.hasOwnProperty(sound)) {
        this.loaded[sound].setVolume(0);
        // this.loaded[sound].pause();
      }
    }
    // for (const possound of Object.keys(Sound.POS_SOUNDS)) {
    //     if (this.posloaded.hasOwnProperty(possound)) {
    //         this.posloaded[possound].setVolume(0);
    //         this.posloaded[possound].pause();
    //     }
    // }
  }

  /**
   * load sounds for positional audio
   * */

  loadPosSounds() {
    const loader = new THREE.AudioLoader();

    for (const posSound of Object.keys(Sound.POS_SOUNDS))
      loader.load(Sound.POS_SOUNDS[posSound], (buffer) => {
        const posaudio = new THREE.PositionalAudio(this.listener);

        posaudio.setLoop(true);
        posaudio.setBuffer(buffer);
        // posaudio.setRefDistance( 75 );
        posaudio.setRolloffFactor(1);
        posaudio.setLoop(true);
        // posaudio.setDirectionalCone(45, 120, 1);
        // posaudio.setMaxDistance(200);
        posaudio.rotation.set(0, 45, 0);

        this.posloaded[posSound] = posaudio;

        // const helper = new PositionalAudioHelper(posaudio, 0.5);
        // posaudio.add(helper);
      });
  }

  playSound(name) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].play();
    }
  }

  pauseSound(name) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].pause();
    }

    if (this.posloaded.hasOwnProperty(name)) {
      this.posloaded[name].pause();
    }
  }

  setVolume(name, level) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].setVolume(level);
    }
  }

  lowerVolume(name) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].setVolume(0);
    }

    if (this.posloaded.hasOwnProperty(name)) {
      this.posloaded[name].setVolume(0);
    }
  }

  playPosSound(name) {
    if (this.posloaded.hasOwnProperty(name)) {
      this.posloaded[name].play();
    }
  }

  pausePosSound(name) {
    if (this.posloaded.hasOwnProperty(name)) {
      this.posloaded[name].pause();
    }
  }

  loop(name) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].setLoop(true);
    }
  }

  noloop(name) {
    if (this.loaded.hasOwnProperty(name)) {
      this.loaded[name].setLoop(false);
    }
  }

  setPosDistance(refD, maxD) {
    for (const posSound of Object.keys(this.posloaded)) {
      this.posloaded[posSound].setRefDistance(refD);
      this.posloaded[posSound].setMaxDistance(maxD);
    }
  }

  setPosCone(a, b, c) {
    for (const posSound of Object.keys(this.posloaded)) {
      this.posloaded[posSound].setDirectionalCone(a, b, c);
    }
  }
}
